import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useUnitProvider } from '/@/core/context/unit.js';
import settings from '/@/core/settings';
import { setBtnDisabled, setHybrid } from '/@/store/crop-monitoring/actions';
import { getHybrid } from '/@/store/crop-monitoring/selectors';
import useIsMobile from '/@/utils/hooks/is-mobile';
import Title from '/@/v3/components/title';
import colors from '../../theme-provider/colors';
import styles from '../styles.module.css';

const TableProducts = ({ products, cropConfig, data, setData, showIndex = true }) => {
    const dispatch = useDispatch();
    const units = useUnitProvider();
    const hybrid = useSelector(getHybrid);
    const isMobile = useIsMobile();

    useEffect(() => {
        if (!hybrid) dispatch(setBtnDisabled(true));
    }, []);

    const handleSelectHybrid = (hybrid) => {
        dispatch(setHybrid(hybrid));
        setData({ ...data, hybrid });
    };

    const handleOnChange = (event, product) => {
        if (event.target.checked) {
            dispatch(setBtnDisabled(false));
            handleSelectHybrid(product);
        } else {
            dispatch(setBtnDisabled(true));
            handleSelectHybrid(undefined);
        }
    };

    const setBgColor = (productId, t) => {
        return settings.app.theme === 'expertobayer'
            ? t.palette.primary[100]
            : cropConfig[`${cropConfig.crop}Products`]
              ? cropConfig[`${cropConfig.crop}Products`].some((p) => p === productId)
                  ? colors.success[100]
                  : colors.themes.dekalb.accent.default
              : colors.themes.dekalb.accent.default;
    };

    return (
        <Grid container>
            {products.map((product, index) => {
                return (
                    <Grid item xs={12} key={product.id}>
                        <Grid
                            container
                            direction='row'
                            alignItems='center'
                            sx={{
                                borderTop: index === 0 ? 2 : 1,
                                borderBottom: index === products.length - 1 ? 2 : 1,
                                borderColor: (t) =>
                                    settings.app.theme === 'expertobayer'
                                        ? t.palette.primary.main
                                        : colors.themes.dekalb.secondary.default,
                                height: '100%',
                                ...(hybrid === product.id && {
                                    backgroundColor: (t) =>
                                        settings.app.theme === 'expertobayer'
                                            ? t.palette.primary[100]
                                            : colors.themes.dekalb.primary[100],
                                }),
                            }}
                        >
                            {showIndex && (
                                <Grid
                                    item
                                    sx={{
                                        bgcolor: (t) => setBgColor(product.id, t),
                                        width: isMobile ? '10%' : '5%',
                                        textAlign: 'center',
                                        height: '100%',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Title className={styles.dataTable}>
                                        {'#'}
                                        {index + 1}
                                    </Title>
                                </Grid>
                            )}
                            <Grid item sx={{ textAlign: 'initial', width: isMobile ? '10%' : '5%' }}>
                                <Checkbox
                                    onChange={(event) => handleOnChange(event, product.id)}
                                    disabled={hybrid && hybrid !== product.id}
                                    checked={hybrid === product.id}
                                    sx={{
                                        color: (t) =>
                                            settings.app.theme === 'expertobayer'
                                                ? t.palette.primary[100]
                                                : colors.themes.dekalb.accent.default,
                                    }}
                                />
                            </Grid>
                            <Grid
                                item
                                sx={{
                                    textAlign: 'initial',
                                    width: isMobile ? '65%' : '85%',
                                }}
                            >
                                <Title className={styles.dataTable}>{product.product.catalogName}</Title>
                            </Grid>
                            <Grid item sx={{ textAlign: 'end', width: isMobile ? '15%' : '5%' }}>
                                <Title className={styles.dataTable}>
                                    {product.estimatedYield
                                        ? units.toYield(product.estimatedYield, product.product.brand.type).localeValue
                                        : ''}
                                </Title>
                            </Grid>
                        </Grid>
                    </Grid>
                );
            })}
        </Grid>
    );
};

export default TableProducts;
